import { render, staticRenderFns } from "./WidgetReportGenerated.vue?vue&type=template&id=8db378d0&scoped=true&lang=pug"
import script from "./WidgetReportGenerated.vue?vue&type=script&lang=ts"
export * from "./WidgetReportGenerated.vue?vue&type=script&lang=ts"
import style0 from "./WidgetReportGenerated.vue?vue&type=style&index=0&id=8db378d0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db378d0",
  null
  
)

/* custom blocks */
import block0 from "./WidgetReportGenerated.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fcomponents%2FReport%2FWidgetReportGenerated.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports